import axios, { AxiosResponse } from "axios";
import axiosInstance from "../../../interceptors/axiosInstance";
import { Conyuge } from "../models/conyuge";
import { ParticipanteRequest } from "../models/participantes";

const getConyuge = async (data: ParticipanteRequest) => {
    const response: AxiosResponse = await axiosInstance.get(
        `siscred-api-participantes/v1/participante-conyuge/obtener-conyuge?rut=${data.rut}&mutuoId=${data.mutuoId}`
    );
    return response;
};

const actualizarConyuge = async (data: Conyuge) => {

    const response: AxiosResponse = await axiosInstance.put(`siscred-api-participantes/v1/participante-conyuge/actualizar/conyuge/${data.rut}`, data);

    return response;
}
const guardarConyuge = async (data: Conyuge) => {

    const response: AxiosResponse = await axiosInstance.post(`siscred-api-participantes/v1/participante-conyuge/guardar-conyuge`, data);

    return response;
}

const deleteConyuge = async (data: ParticipanteRequest) => {

    const axiosResponse: Promise<AxiosResponse> = axiosInstance.delete(`siscred-api-participantes/v1/participante-conyuge/eliminar/conyuge/${data.mutuoId}`, {
        params: {
            rut: data.rut,
            mutuoId: data.mutuoId
        }
    });

    return axiosResponse;
}

export {
    getConyuge,
    actualizarConyuge,
    guardarConyuge,
    deleteConyuge
}